import { z } from 'zod';

import { MAX_VARIANTS } from './creative.js';
import { creativeTypeSchema } from './enums.js';
import { studioParamsSchema } from './studio.js';
import { videoParamsSchema } from './video.js';

/**
 * UR4/KS3 — kreatif maliyet önizlemesinin gövdesi (`POST /creatives/estimate`).
 *
 * 18 Eyl 2026'da `apps/api/src/creative/creative.schemas.ts`ten buraya
 * taşındı: geliştirici API'sinin sözleşme kaydı (`developer-api.ts`) ve MCP
 * sunucusu aynı şemayı okumak zorunda, ikinci bir kopya sessizce sapardı.
 * API tarafındaki `estimateSchema` adı bu tanıma işaret ediyor.
 *
 * AYRI DOSYA ve bu bir tercih değil: `studio.ts` `creative.ts`ten değer import
 * ediyor; şema `creative.ts`e konsaydı iki dosya birbirini import eder ve
 * modül yüklenirken biri `undefined` görürdü.
 *
 * `video` ve `studio` alanlarının neden ZORUNLU bilgi taşıdığı API'deki eski
 * yerinde anlatılıyor: fiyat süre × çözünürlükle (video) ve büyütme katıyla
 * (stüdyo) değişiyor — bu ucu çağırmadan üretmek fiyatı bilmeden satın almak.
 */
export const creativeEstimateSchema = z.object({
  type: creativeTypeSchema,
  variants: z.number().int().min(1).max(MAX_VARIANTS).default(1),
  video: videoParamsSchema.optional(),
  studio: studioParamsSchema.optional(),
});
export type CreativeEstimateInput = z.infer<typeof creativeEstimateSchema>;
